import React from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { FormattedMessage } from "react-intl";

const CloseIcon = ({
  onClick,
  text = "close_without_save",
  children,
}) => {
  return (
    <div className="w-full flex flex-row justify-between items-center gap-6">
      <div className="flex flex-row items-center gap-2 flex-1">
        {children}
      </div>
      <div
        className="flex flex-row items-center cursor-pointer flex-shrink-0"
        onClick={onClick}
      >
        {!!text && (
          <p className="text-gray-400">
            <FormattedMessage id={text} />
          </p>
        )}
        <div className="ml-2 w-10 h-10">
          <XMarkIcon />
        </div>
      </div>
    </div>
  );
};

export default CloseIcon;
